<template>
    <a-card :bordered="false" class="export-config">
      <a-row>
        <a-col :span="4">
          <a-radio-group v-model="category" >
            <a-radio :style="radioStyle" value="1">
              <a style="font-size: 20px">单CRF多记录导出</a>
            </a-radio>
          </a-radio-group>
        </a-col>
        <a-col :span="20" style="border-left: 1px solid rgba(0,0,0,0.1);min-height: calc(100vh - 170px)">
          <div class="view-panel">
            <a-row :gutter="50">
              <a-col :span="18" >
                <div class="title">
                  单CRF多记录导出
                </div>
              </a-col>
              <a-col :span="6" class="btn-col">
                <a-button type="primary" @click="handleConfig('1')">设置</a-button>
              </a-col>
            </a-row>
            <a-row class="row">
              <a-col :span="4" class="label">允许导出：</a-col>
              <a-col :span="20" :style="{color:type1Data.export==='1'?'green':''}">{{type1Data.export==='1'?'开启':'关闭'}}</a-col>
            </a-row>
            <template v-if="type1Data.export==='1'">
              <a-row class="row">
                <a-col :span="4" class="label">可导出属性：</a-col>
                <a-col :span="20">
                  <a-row>
                    <a-col :span="8" v-for="(field,index) in type1Data.fieldConfigData" :key="index">{{`${index+1}、${field.name}`}}</a-col>
                  </a-row>
                </a-col>
              </a-row>
              <a-row class="row">
                <a-col :span="4" class="label">可导出表单：</a-col>
                <a-col :span="20">
                  <a-row>
                    <a-col :span="8" v-for="(field,index) in type1Data.formItemConfigData" :key="index">{{`${index+1}、${field.name}`}}</a-col>
                  </a-row>
                </a-col>
              </a-row>
            </template>
          </div>
          <div class="view-panel">
            <a-row :gutter="50" class="row">
              <a-col :span="18" >
                <div class="title">
                  单CRF单记录导出
                </div>
              </a-col>
              <a-col :span="6" class="btn-col">
                <a-button type="primary" @click="handleConfig('2')">设置</a-button>
              </a-col>
            </a-row>
            <a-row class="row">
              <a-col :span="4" class="label">允许导出：</a-col>
              <a-col :span="20" :style="{color:type2Data.export==='1'?'green':''}">{{type2Data.export==='1'?'开启':'关闭'}}</a-col>
            </a-row>
            <template v-if="type2Data.export==='1'">
              <a-row class="row">
                <a-col :span="4" class="label">可导出属性：</a-col>
                <a-col :span="20">
                  <a-row>
                    <a-col :span="8" v-for="(field,index) in type2Data.fieldConfigData" :key="index">{{`${index+1}、${field.name}`}}</a-col>
                  </a-row>
                </a-col>
              </a-row>
              <a-row class="row">
                <a-col :span="4" class="label">可导出表单：</a-col>
                <a-col :span="20">
                  <a-row>
                    <a-col :span="8" v-for="(field,index) in type2Data.formItemConfigData" :key="index">{{`${index+1}、${field.name}`}}</a-col>
                  </a-row>
                </a-col>
              </a-row>
            </template>
          </div>
        </a-col>
      </a-row>
      <a-modal
        :title="modalTitle"
        :width="1200"
        :visible="visible"
        :confirmLoading="loading"
        @ok="handleSubmit"
        @cancel="handleCancel">
        <a-row >
          <a-col :span="4" class="label">允许导出：</a-col>
          <a-col :span="20" >
            <a-switch v-model="formInfo.exportBl"  />
          </a-col>
        </a-row>
        <template v-if="formInfo.exportBl">
          <a-row class="row">
            <a-col :span="4" class="label">导出表单：</a-col>
            <a-col :span="20" >
              <div>
                <a-checkbox :indeterminate="formInfo.form.indeterminate" :checked="formInfo.form.checkAll" @change="centerCheckChange($event,formInfo.form)">
                  全选
                </a-checkbox>
              </div>
              <div style="width: 100%">
                <a-checkbox-group v-model="formInfo.form.checkedList" style="width: 100%"  @change="onCenterCheckGroupChange($event,formInfo.form)">
                  <a-row >
                    <a-col class="row2" :span="8" v-for="(item,index) in formInfo.form.dataList" :key="index">
                      <a-checkbox :value="item.value" class="one-row row-bottom" >
                        <a-tooltip>
                          <template slot="title">
                            {{item.name}}
                          </template>
                          {{item.name}}
                        </a-tooltip>
                      </a-checkbox>
                    </a-col>
                  </a-row>
                </a-checkbox-group>
              </div>
            </a-col>
          </a-row>
          <a-row class="row">
            <a-col :span="4" class="label">导出属性：</a-col>
            <a-col :span="20" >
              <a-table
                size="middle"

                rowKey="rowKey"
                :columns="attrColumns"
                :dataSource="formInfo.attrData"
                :pagination="false"
              >
                <span slot="action" slot-scope="text, record,index">
                  <a @click="attrRemove(index)">删除</a>
                </span>
                <span slot="sortNum" slot-scope="text, record,index">
                    <a-input-number v-model="record.sortNum" :min="0" :precision="0" style="width: 80%"/>
                </span>
                <div slot="id" slot-scope="text, record,index">
                  <a-select v-model="record.id" placeholder="请选择" style="text-align:center;width: 80%" @change="selectChange(record)">
                    <a-select-option
                      :disabled="fieldDisabled(item.id)"
                      v-for="item in fieldList"
                      :key="item.id"
                      :value="item.id">
                      {{ item.name }}
                    </a-select-option>
                  </a-select>
                </div>
              </a-table>
              <div class="row">
                <a-button icon="plus" size="small" @click="attrAdd"> 新增</a-button>
              </div>
            </a-col>
          </a-row>
        </template>
      </a-modal>
    </a-card>
</template>

<script>
  import manyCheck from '@/utils/components/manyCheck'
  import { CACHE_PROJECT_ID,CACHE_PROJECT_NAME } from '@/constants/project'
  import { getAction,postAction } from '@/api/manage'
  import Vue from 'vue'
  export default {
    name: 'Config',
    data(){
      return{
        loading:false,
        projectId: Vue.ls.get(CACHE_PROJECT_ID),
        category:'1',
        radioStyle: {
          display: 'block',
          height: '30px',
          lineHeight: '30px',
        },
        visible:false,
        fieldList:[],
        attrColumns:[
          {
            title: '序号',
            dataIndex: 'sortNum',
            key: 'sortNum',
            width: 80,
            scopedSlots: {customRender: 'sortNum'},
            align: "center",
          },
          {
            title: '校验信息',
            dataIndex: 'id',
            key: 'id',
            width: 200,
            scopedSlots: {customRender: 'id'},
            align: "center",
          },
          {
            title: '操作',
            dataIndex: 'action',
            key: 'action',
            width: 120,
            scopedSlots: {customRender: 'action'},
            align: "center",
          },
        ],
        modalTitle:'',
        formInfo:{
          exportBl:false,
          type:'',
          attrData:[],
          form:{
            indeterminate:false,
            checkedList:[],
            checkAll:false,
            dataList:[]
          },
        },
        type1Data:{
          fieldConfigData:[],
          formItemConfigData:[],
        },
        type2Data:{
          fieldConfigData:[],
          formItemConfigData:[],
        },
      }
    },
    mounted(){
      this.loadData()
    },
    methods:{
      loadData(){
        // 获取字段
        getAction('/project/projectPatientField/listAll',{projectId:this.projectId,exportData:'1'}).then(res=>{
          if(res.success) {
            this.fieldList = res.result
          }
        })
        // 获取已配置对象
        getAction('/export/projectOneCrfExport/getOrCreate',{projectId:this.projectId}).then(res=>{
            if(res.success){
              const dataList = []
              res.result.forEach(item=>{
                dataList.push({
                  value:item.id,
                  name:name
                })
                if(item.fieldConfig){
                  item.fieldConfigData = JSON.parse(item.fieldConfig)
                }else{
                  item.fieldConfigData=[]
                }
                if(item.formItemConfig){
                  item.formItemConfigData = JSON.parse(item.formItemConfig)
                }else{
                  item.formItemConfigData=[]
                }
                if(item.type==='1'){
                  this.type1Data = item
                }
                else if(item.type==='2'){
                  this.type2Data = item
                }

              })
              this.formInfo.form.dataList = dataList
            }
        })
        // 获取表单
        getAction('/project/projectForm/listAll',{projectId:this.projectId,status:'1'}).then(res=>{
          if(res.success) {
            const dataList = []
            res.result.forEach(item=>{
              dataList.push({
                value:item.id,
                name:item.name,
              })
            })
            this.formInfo.form.dataList = dataList
          }
        })
      },
      selectChange(record){
        this.$nextTick(()=>{
          this.fieldList.forEach(field=>{
            if(field.id===record.id){
              record.name = field.name
            }
          })
        })
      },
      handleSubmit(){
        if(this.formInfo.exportBl){
          if(this.formInfo.form.checkedList.length===0){
            return this.$message.warning('请选择导出表单')
          }
          if(this.formInfo.attrData.length===0){
            return this.$message.warning('请选择导出属性')
          }
          let error = false
          this.formInfo.attrData.forEach(item=>{
            if(error){
              return
            }
            if(!(item.sortNum+'') || !item.id){
              error=true
              return this.$message.warning('请填写完整导出属性')
            }
          })
          if(error){
            return
          }
        }
        const params = {
          id:this.formInfo.id,
          projectId:this.formInfo.projectId,
          type:this.formInfo.type,
          export:this.formInfo.exportBl?'1':'0',
          fieldConfig:JSON.stringify(this.formInfo.attrData)
        }
        const formItemConfigData = []
        this.formInfo.form.dataList.forEach(item=>{
          if(this.formInfo.form.checkedList.indexOf(item.value)>=0){
            formItemConfigData.push({
              id:item.value,
              name:item.name
            })
          }
        })
        params.formItemConfig = JSON.stringify(formItemConfigData)
        this.loading = true
        postAction('/export/projectOneCrfExport/edit',params).then(res=>{
          if(res.success){
            this.loadData()
            this.handleCancel()
          }
        }).finally(()=>{
          this.loading = false
        })
      },
      handleCancel(){
        this.visible = false
      },
      handleConfig(type){
        const typeData = type==='1'?this.type1Data:this.type2Data
        {
          this.formInfo.id=typeData.id
          this.formInfo.projectId=typeData.projectId
          this.formInfo.type=type
          this.formInfo.attrData = JSON.parse(JSON.stringify(typeData.fieldConfigData))
          this.formInfo.export = typeData.export
          this.formInfo.exportBl = typeData.export==='1'
          const checkedList = []
          typeData.formItemConfigData.forEach(item=>{
            checkedList.push(item.id)
          })
          this.formInfo.form.checkedList = checkedList
          this.formInfo.form.checkAll = this.formInfo.form.checkedList.length === this.formInfo.form.dataList.length
        }
        this.modalTitle = type ==='1'?'单CRF多记录导出':'单CRF单记录导出'
        this.visible = true
      },
      attrRemove(index){
        this.formInfo.attrData.splice(index,1)
      },
      attrAdd(){
        this.formInfo.attrData.push({})
      },
      centerCheckChange(e,groupInfo){
        manyCheck.centerCheckChange(e,groupInfo)
      },
      onCenterCheckGroupChange(e,groupInfo,parent){
        manyCheck.onCenterCheckGroupChange(e,groupInfo,parent)
      },
      fieldDisabled(value){
        let result = false
        this.formInfo.attrData.forEach(record=>{
          if(record.id===value){
            result = true
          }
        })
        return result
      }
    }
  }
</script>

<style scoped lang="less">

  .export-config{
    .view-panel{
      padding-left: 20px;
      padding-right: 20px;
    }
  }
  .label{
    text-align: right;
    padding-right: 20px;
  }
  .title{
    font-weight: bold;
    font-size: 18px;
    padding-left: 10px;
    border-left: 5px solid @primary-color;
  }

  .row{
    margin-top: 20px;
  }
  .row2{
    margin-top: 5px;
  }
  .btn-col{
    text-align: right;
  }
</style>